import { Page, Spinner, TopBar } from "@/components/kit";
import { Switch } from "@/components/ui/switch";
import { useNotifPrefs, useUpdateNotifPrefs } from "@/hooks/queries";

const ROWS = [
  ["reminders", "Follow-up reminders", "When a follow-up you scheduled is due"],
  ["scanAlerts", "Scan alerts", "Scan results and free-scan limit alerts"],
  ["subscription", "Subscription", "Premium purchase, renewal and expiry updates"],
  ["announcements", "Announcements", "News and offers from the TOTO team"],
];

export default function NotificationSettings() {
  const prefs = useNotifPrefs();
  const update = useUpdateNotifPrefs();
  return (
    <Page>
      <TopBar title="Notification Settings" />
      {prefs.isLoading ? <Spinner /> : (
        <div className="t-card divide-y divide-[#E2E8F0] mt-2 max-w-2xl">
          {ROWS.map(([k, title, desc]) => (
            <label key={k} className="flex items-center gap-4 p-4 cursor-pointer">
              <span className="flex-1"><span className="block text-[15px] font-bold">{title}</span><span className="text-[13px] text-[#64748B]">{desc}</span></span>
              <Switch checked={!!prefs.data?.[k]} onCheckedChange={(v) => update.mutate({ [k]: v })} data-testid={`notif-toggle-${k}`} />
            </label>
          ))}
        </div>
      )}
    </Page>
  );
}
